import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import GridModal from '../../Components/Modal_Grid';
import AgDatePicker from '../../Components/agGrid/ag-DatePickerMM10020';
import BasicInput from '../../Components/Input_Basic';
import BasicCombo from '../../Components/Combo_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';

function MM10020(props) {
    React.useEffect(() => {
        document.title = '작업지시관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>작업지시관리</strong>" +
            '</h1>';
    }, []);
    const gridModalRef = React.useRef();
    const [modalToggle, setModalToggle] = React.useState(false); //자재등록 팝업
    const [modalToggle1, setModalToggle1] = React.useState(false); //자재등록 안 품목설정 팝업
    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
    });
    const [selectedModalData, setSelectedModalData] = React.useState([]);
    const [selectedModalData2, setSelectedModalData2] = React.useState([]);
    const [selectedRowData, setSelectedRowData] = React.useState({
        woNo: '',
        itemCd: '',
        workQty: '',
    });
    let _workQty = '';
    const gridRef = React.useRef();
    //그리드 컬럼
    const columnDefs = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 80,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            // cellRenderer: (e) => {
            //   return !e.data ? "TOTAL" : e.data.no;
            // },
        },
        {
            field: 'soDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDate' && f.lanType === 'COL')[0].lanName
                    : '', //주문일자
            editable: false,
            minWidth: 120,
        },
        {
            field: 'workDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkDt' && f.lanType === 'COL')[0].lanName
                    : '', //작업지시일자
            editable: false,
            minWidth: 150,
            sort: 'desc',
        },

        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장코드
            cellRenderer: Commons.CustomPlantRenderer,
        },
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
        },
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProductionWhCd' && f.lanType === 'COL')[0].lanName
                    : '', //생산창고
            editable: (e) => (e.data.woNo === null ? true : false),
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: props.inputs.comboInwh,
                default: props.inputs.comboValue,
            },
            cellRenderer: (value) => {
                if (value == undefined || value == 'undefined' || value == null || !value) {
                    //value가 없을때
                } else {
                    if (!value.data) {
                        //value.data가 없을때
                    } else {
                        if (value.data.whNm == null) {
                        } else {
                            if (value.data.whNm.name != undefined) {
                                return (
                                    <div
                                        style={{
                                            color:
                                                value.data.whNm.name === '[부산][입고][B][IN-warehouse]' ||
                                                value.data.whNm.name === '[부산][B][생산][Production]'
                                                    ? 'orange'
                                                    : value.data.whNm.name === '[서울][입고][S][IN-warehouse]' ||
                                                      value.data.whNm.name === '[서울][S][생산][Production]'
                                                    ? 'green'
                                                    : value.data.whNm.name === '[베트남][입고][V][IN-warehouse]' ||
                                                      value.data.whNm.name === '[베트남][V][생산][Production]'
                                                    ? 'blue'
                                                    : value.data.whNm.name === '[중국][입고][C][入庫倉庫]' ||
                                                      value.data.whNm.name === '[중국][생산]生產倉庫'
                                                    ? 'red'
                                                    : '',
                                        }}
                                    >
                                        {value.data.whNm.name}
                                    </div>
                                );
                            } else {
                                return (
                                    <div
                                        style={{
                                            color:
                                                value.data.whNm === '[부산][입고][B][IN-warehouse]' ||
                                                value.data.whNm === '[부산][B][생산][Production]'
                                                    ? 'orange'
                                                    : value.data.whNm === '[서울][입고][S][IN-warehouse]' ||
                                                      value.data.whNm === '[서울][S][생산][Production]'
                                                    ? 'green'
                                                    : value.data.whNm === '[베트남][입고][V][IN-warehouse]' ||
                                                      value.data.whNm === '[베트남][V][생산][Production]'
                                                    ? 'blue'
                                                    : value.data.whNm === '[중국][입고][C][入庫倉庫]' ||
                                                      value.data.whNm === '[중국][생산]生產倉庫'
                                                    ? 'red'
                                                    : '',
                                        }}
                                    >
                                        {value.data.whNm}
                                    </div>
                                );
                            }
                        }
                    }
                }
            },
            minWidth: 120,
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'stusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StatusName' && f.lanType === 'COL')[0].lanName
                    : '', //상태명
            cellStyle: { textAlign: 'center' },
            cellRenderer: Commons.CustomHeaderRenderer,
        },
        {
            field: 'bomItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StatusName' && f.lanType === 'COL')[0].lanName
                    : '', //자재품목코드
            hide: true,
        },
        {
            field: 'bomItemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BomPopup' && f.lanType === 'COL')[0].lanName
                    : '', //자재등록 품목선택
            cellRenderer: (e) => {
                if (e.data.stusNm == '주문완료' || (e.data.stusNm == '출하지시' && e.data.woNo == null)) {
                    return (
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemChose' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : ''
                            }
                            onClick={() => {
                                // props.setSelectedRowData({
                                //   ...props.selectedRowData,
                                //   soDueDt: e.data.soDueDt,
                                //   soNo: e.data.soNo,
                                //   itemCd: e.data.itemCd,
                                // });
                                props.SearchItemBomLogic(e.data.soNo, e.data.soDueDt, e.data.itemCd);
                                AuthGroupSettingClicked(e);
                            }}
                        />
                    );
                } else {
                    return e.value;
                }
            },
            minWidth: 130,
            //   headerCheckboxSelection: true,
            //   checkboxSelection: true,
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 250,
        },

        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_OrderQty' && f.lanType === 'COL')[0].lanName
                    : '', //주문수량
            minWidth: 110,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'workQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkQty' && f.lanType === 'COL')[0].lanName
                    : '', //지시수량
            editable: (e) => (e.data.woNo === null ? true : false),
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'wonjiQty1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WonjiQty1' && f.lanType === 'COL')[0].lanName
                    : '', //원지1 재단수량
            editable: (e) => (e.data.woNo === null ? true : false),
            minWidth: 130,
            cellDataType: 'number',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'wonjiQty2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WonjiQty2' && f.lanType === 'COL')[0].lanName
                    : '', //원지2 재단수량
            editable: (e) => (e.data.woNo === null ? true : false),
            minWidth: 130,
            cellDataType: 'number',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'soItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemCost' && f.lanType === 'COL')[0].lanName
                    : '', //품목단가
            suppressMovable: true,
            minWidth: 110,

            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'soItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '', //금액
            minWidth: 110,

            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value ? params.value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'soItemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemVat' && f.lanType === 'COL')[0].lanName
                    : '', //부가세
            minWidth: 110,

            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //납기번호
            minWidth: 100,
            suppressMovable: true,
        },
        {
            field: 'soDueNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueNo' && f.lanType === 'COL')[0].lanName
                    : '', //납기번호
            minWidth: 100,
            suppressMovable: true,
        },
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '', //납기일
            minWidth: 130,
            suppressMovable: true,
        },
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '', //주문번호
            editable: false,
        },
        {
            field: 'woNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WoNo' && f.lanType === 'COL')[0].lanName
                    : '', //작업지시번호
            editable: false,
            minWidth: 130,
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
    ];
    // 자재등록 그리드
    const AuthGroupGridColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 80,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            // cellRenderer: (e) => {
            //   return !e.data ? "TOTAL" : e.data.no;
            // },
        },
        //창고
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            hide: true,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
            cellRenderer: (e) => {
                return e.data.bomItemCd ? (
                    <span style={{ color: 'black' }}>{e.data.itemNm}</span>
                ) : e.data.no == null ? (
                    <BasicButton name="설정하기" onClick={() => AuthGroupSettingClicked1(e)} />
                ) : (
                    <span style={{ color: 'black' }}>{}</span>
                );
            },
        },
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'bomItemUseage',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BomItemUseage' && f.lanType === 'COL')[0].lanName
                    : '', //소요량
            editable: true,
            cellStyle: { textAlign: 'right' },
            editable: true,
            cellDataType: 'number',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'itemTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //품목단위
        },
        {
            field: 'totalAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_TotalAmt' && f.lanType === 'COL')[0].lanName
                    : '', //총금액
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '', //비고
            editable: true,
            minWidth: 300,
        },
        {
            field: 'bomItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
    ];
    //자재등록 버튼 안 품목설정
    const AuthGroupGridColumnDef2 = [
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
        },
        //창고
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            hide: true,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
        },
        // {
        //   field: "itemCd",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //품목코드
        // },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 200,
        },
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
        },
        //발주수량
        {
            field: 'stockAddQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value.toFixed(2)
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 100,
        },
        //재고수량(BOM)
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Calculate_Qty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 140,
        },

        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 100,
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        //금액
        {
            field: 'soItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 100,
        },
    ];

    const AuthGroupSettingClicked = (_data) => {
        // setSelectedRowData1({ ..._data.data });
        setModalToggle(true);
        // setCheckInputs({
        //   ...checkInputs,
        //   value1: "",
        // });
        // props.setAuthGroupGridRowData1([]);
    };
    const AuthGroupSettingClicked1 = (_data) => {
        // setSelectedRowData1({ ..._data.data });
        setModalToggle1(true);
        // setCheckInputs({
        //   ...checkInputs,
        //   value1: "",
        // });
        // props.setAuthGroupGridRowData1([]);
    };
    return (
        <div>
            <div>
                <div style={{ height: '100%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{
                                    width: '120px',
                                    marginRight: '5px',
                                    marginLeft: '5px',
                                }}
                                selected={props.startDate}
                                onChange={(e) => {
                                    props.setStartDate(e);
                                }}
                            />
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.endDate}
                                onChange={(e) => {
                                    props.setEndDate(e);
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {/* 인쇄 버튼 */}
                            <BasicButton
                                name={
                                    props.lanData.length > 0
                                        ? props.lanData.filter((f) => f.lanId === 'Btn_Print' && f.lanType === 'BTN')[0]
                                              .lanName
                                        : ''
                                }
                                onClick={() => props.Print()}
                            />
                            {/* 작업지시 버튼 */}
                            <BasicButton
                                name={
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_WorkInstruction' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : ''
                                }
                                onClick={(e) => {
                                    // props.SaveConfirm();
                                    props.setDialogToggle(true);
                                }}
                            />
                            {/* 그리드 버튼  */}
                            <AuthGroupButton
                                pageName="MM10020"
                                target="G01"
                                refreshNone="none"
                                refreshFunc={() => {
                                    props.SearchLogic();
                                }}
                                selectFunc={() => {
                                    props.SearchLogic();
                                }}
                                saveFunc={() => props.SaveConfirm()}
                                deleteFunc={() => {
                                    for (let i = 0; i < props.selectedRowData.length; i++) {
                                        if (
                                            props.selectedRowData[i].stusNm === '주문완료' ||
                                            props.selectedRowData[i].stusNm === '생산중'
                                        ) {
                                            props.DeleteConfirm();
                                        } else {
                                            props.setSnackbars({
                                                toggle: true,
                                                type: 'info',
                                                message: props.lanData.filter(
                                                    (f) => f.lanId === 'Snack_DataNotDelete' && f.lanType === 'SNACK'
                                                )[0].lanName,
                                            });
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 그리드  */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            frameworkComponents={{
                                customHeaderRenderer: Commons.CustomHeaderRenderer,
                            }}
                            onCellValueChanged={(e) => {
                                props.setChangedRowData(e.data);
                                setSelectedRowData({
                                    ...selectedRowData,
                                    itemCd: e.data.itemCd,
                                    workQty: e.data.workQty,
                                });
                                // GridFunctions.onCellValueChanged(
                                //   e,
                                //   gridRef,
                                //   props.setChangedRowData
                                // );
                            }}
                            rowData={props.rowData}
                            rowSelection="multiple"
                            onSelectionChanged={(e) => {
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData);
                            }}
                        />
                        {/* 자재등록 팝업 */}
                        {modalToggle && (
                            <GridModal
                                conditions={[]}
                                name="품목 설정"
                                onClose={() => setModalToggle(false)}
                                gridColumn={AuthGroupGridColumnDef}
                                gridRowData={props.authGroupGridRowData}
                                buttonName1="저장"
                                notButton="0"
                                gridRowSelection={'multiple'}
                                containerStyle={{ width: '80%' }}
                                gridOnClick={(e) => {
                                    let data = [];
                                    for (let i = 0; i < e.length; i++) {
                                        data.push({
                                            itemCd: e[i].bomItemCd,
                                        });
                                    }
                                    props.setSelectedModalData2(data);
                                }}
                                onCellValueChanged={(e) => {
                                    let rowIndex = e.rowIndex;
                                    if (e.oldValue !== e.newValue) {
                                        if (e.data.check === '') {
                                            props.setAuthGroupGridRowData([
                                                {
                                                    // whCd: e.data.whCd,
                                                    bomItemCd: e.data.bomItemCd,
                                                    bomItemUseage: e.data.bomItemUseage,
                                                    totalAmt: e.data.bomItemUseage * e.data.itemStdAmt,
                                                },
                                                ...props.authGroupGridRowData,
                                            ]);
                                            props.setChangedRowData1((current) => [...current]);
                                        }
                                        props.authGroupGridRowData.map((item, index) => {
                                            if (index === rowIndex) {
                                                // item.whCd = e.data.whCd;
                                                item.bomItemCd = e.data.bomItemCd;
                                                item.bomItemUseage = e.data.bomItemUseage;
                                                item.totalAmt = e.data.bomItemUseage * e.data.itemStdAmt;
                                            }
                                        });
                                        props.setChangedRowData1((current) => [...current]);
                                    }
                                }}
                                gridOnDoubleClick={(e) => false}
                                addLogic={() => {}}
                                deleteLogic={() => {
                                    props.DeleteBomLogic();
                                }}
                                execLogic={(e) => {
                                    props.CreateWorkOrderBom();
                                }}
                            />
                        )}
                        {/* 자재 등록 팝업 안 품목설정 */}
                        {modalToggle1 && (
                            <GridModal
                                conditions={[
                                    {
                                        type: 'input',
                                        name: '품목 코드',
                                        value: checkInputs.value,
                                        onChange: (e) => {
                                            setCheckInputs({
                                                ...checkInputs,
                                                value: e.target.value,
                                            });
                                        },
                                        onClick: (e) => {
                                            // document.getElementsByName("품목코드/명").focus;
                                        },
                                        onKeyDown: (e) => {
                                            props.GetItemList(checkInputs.value);
                                        },
                                    },
                                    {
                                        type: 'button',
                                        style: {
                                            width: '100px',
                                        },
                                        name: '조회',
                                        onClick: (e) => {
                                            props.GetItemList(checkInputs.value);
                                        },
                                    },
                                ]}
                                name="품목 설정"
                                onClose={() => setModalToggle1(false)}
                                gridColumn={AuthGroupGridColumnDef2}
                                gridRowData={props.authGroupGridRowData2}
                                containerStyle={{ width: '80%' }}
                                buttonName1="저장"
                                gridRowSelection={'multiple'}
                                gridOnClick={(e) => {
                                    let data = [];
                                    for (let i = 0; i < e.length; i++) {
                                        data.push({
                                            plantCd: e[i].plantCd,
                                            itemCd: e[i].itemCd,
                                            itemNm: e[i].itemNm,
                                            itemType: e[i].itemType,
                                            itemStdAmt: e[i].itemStdAmt,
                                            updateId: e[i].updateId,
                                            itemUnitNm: e[i].itemUnitNm,
                                            orSeq: e[i].orSeq,
                                        });
                                    }
                                    setSelectedModalData2(data);
                                }}
                                gridOnDoubleClick={(e) => false}
                                execLogic={(e) => {
                                    let index = -1;

                                    for (let i = 0; i < props.authGroupGridRowData2.length; i++) {
                                        if (props.authGroupGridRowData2[i].itemCd === selectedModalData2[0].itemCd) {
                                            index = i;
                                        }
                                    }

                                    props.setAuthGroupGridRowData([
                                        {
                                            bomItemCd: props.authGroupGridRowData2[index].itemCd,
                                            plantCd: props.authGroupGridRowData2[index].plantCd,
                                            // bomItemCd: selectedModalData2[0].bomItemCd,
                                            itemNm: props.authGroupGridRowData2[index].itemNm,
                                            itemType: props.authGroupGridRowData2[index].itemType,
                                            itemStdAmt: props.authGroupGridRowData2[index].itemStdAmt,
                                            updateId: props.authGroupGridRowData2[index].updateId,
                                            orSeq: props.authGroupGridRowData2[index].orSeq,
                                            itemTypeNm: props.authGroupGridRowData2[index].itemUnit,
                                            whCd: props.authGroupGridRowData2[index].whCd,
                                            whNm: props.authGroupGridRowData2[index].whNm,
                                        },
                                        ...props.authGroupGridRowData,
                                    ]);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MM10020;
